import { Fragment } from 'react';
import { formatMoney_2, NumberToNepaliNum } from '../../../../../../helpers/DateFormat';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../../store/store';
import { useLanguage } from '../../../../../../context/LanguageProvider';
import { ToWords } from 'to-words';

const BillPrintView = () => {
    const { BillingList } = useSelector((state: RootState) => state.inventory);
    const { SOFTWARE_ORG } = useSelector((state: RootState) => state.software);
    const org_details = SOFTWARE_ORG?.org;
    const { language } = useLanguage();
    const totalAmount = BillingList?.receipt_list?.reduce(
    (total, voucher) => total + (voucher?.cramt || 0), 
    0
    );
    const toWords = new ToWords({
        localeCode: 'en-IN',
        converterOptions: {
            currency: true,
            ignoreDecimal: false,
            ignoreZeroCurrency: false,
            doNotAddOnly: false,
            currencyOptions: {
                name: 'Rupee',
                plural: 'Rupees',
                symbol: '₹',
                fractionalUnit: {
                    name: 'Paisa',
                    plural: 'Paise',
                    symbol: '',
                },
            },
        },
    });
    const toNpWords = new ToWords({
        localeCode: 'np-NP',
        converterOptions: {
            currency: true,
            ignoreDecimal: false,
            ignoreZeroCurrency: false,
            doNotAddOnly: false,
            currencyOptions: {
                name: 'Rupee',
                plural: 'रुपैयाँ',
                symbol: '₹',
                fractionalUnit: {
                    name: 'Paisa',
                    plural: 'Paise',
                    symbol: '',
                },
            },
        },
    });

    console.log(totalAmount)
    return (
        <Fragment>
            <style>
                {`@media print {
                        @page {
                            size: A4 portrait;
                            page-break-before: always;
                            margin: 0.2in; 
                        }
                    }`}
            </style>
            <div className='grid grid-cols-2 gap-1'>
                <div className='bg-white m-1 h-[50vh] border border-gray-700 flex flex-col justify-between'>
                    <div className="relative p-2">
                        <table className="w-full text-sm text-left rtl:text-right text-black">
                            <tbody>
                                <tr>
                                    <td className={`w-[25%] text-[10px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        {language === "Eng" ? "Reg. No: " : "दर्ता नं.:"}:  {language === "Eng" ? org_details?.org_reg : NumberToNepaliNum(org_details?.org_reg || "")}
                                    </td>
                                    <td className="w-[25%]" style={{ padding: 0, margin: 0 }}>
                                    </td>
                                    <td className="w-[25%]" style={{ padding: 0, margin: 0 }}>
                                    </td>
                                    <td align='right' className={`w-[25%] text-[10px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        {language === "Eng" ? "Phone: " : "फोन नम्बर:"}  {language === "Eng" ? org_details?.org_phone : NumberToNepaliNum(org_details?.org_phone || 0)}
                                    </td>
                                </tr>
                                <tr>
                                    <td align='center' colSpan={4} className={`w-[100%] text-black font-bold text-[15px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        {language === "Eng" ? org_details?.org_name : org_details?.org_name_nep}
                                    </td>
                                </tr>
                                <tr>
                                    <td align='center' colSpan={4} className={`w-[25%] text-black font-medium text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        {language === "Eng" ? org_details?.org_add : org_details?.org_add_nep}
                                    </td>
                                </tr>
                                <tr>
                                    <td align='center' colSpan={4} className={`w-[25%] text-black font-bold text-[12px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        <span className='underline'>{language === "Eng" ? "Consumer Receipt" : "उपभोक्ता रसिद"}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="relative mt-1">
                        <table className='w-full'>
                            <thead className="text-[12px] text-black capitalize">
                                <tr>
                                    <td align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Receipt No: " : "रसिद नं: "} {language === "Eng" ? BillingList?.receipt_no : BillingList?.receipt_no}
                                    </td>
                                    <td align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Date: " : "मिति: "} {language === "Eng" ? BillingList.date_ne || "" : BillingList.date_ne || ""}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Name: " : "नाम: "} {language === "Eng" ? BillingList.member_details?.mem_name : BillingList.member_details?.mem_name_nep}
                                    </td>
                                </tr>
                                <tr>
                                    <td align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                       {language === "Eng" ? "Address: " : "ठेगाना: "} {language === "Eng" ? BillingList.member_details?.add_eng : BillingList.member_details?.add_nep}-{BillingList?.member_details?.ward_no || ""}
                                    </td>
                                    <td align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Marga/Tole: " : "मार्गा/टोल: "} {language === "Eng" ? BillingList.member_details?.tole_name : BillingList.member_details?.tole_name_nep}
                                    </td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div className="relative mt-1">
                        <table className="w-full text-sm text-left rtl:text-right text-black">
                            <thead className="text-[10px] text-black capitalize bg-gray200">
                                <tr>
                                    <td align='center' className={`px-1 border-y font-bold border-gray-300 w-10 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "S.N." : "स.नं."}
                                    </td>
                                    <td align='center' className={`px-1 border-[1px] font-bold border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Particulars" : "विवरणहरु"}
                                    </td>
                                    <td align='center' className={`px-1 border-y font-bold border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Amount" : "रकम"}
                                    </td>
                                </tr>
                            </thead>
                            <tbody className="text-[10px] font-normal text-gray600 capitalize">
                                {BillingList &&
                                    BillingList?.receipt_list?.map((voucher: any, index: number) => (
                                        <tr key={index} className='text-black'>
                                            <td align='center' className={`px-2 border-y font-normal border-gray-300 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                                {language === "Eng" ? index + 1 : NumberToNepaliNum(index + 1)}.
                                            </td>
                                            <td align='left' className={`px-2 font-normal border border-gray-300 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                                {language === "Eng" ? voucher?.particularname : voucher?.particularnamenep}.
                                            </td>
                                            <td align='right' className={`px-2 border-y border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                                {language === "Eng" ? formatMoney_2(voucher?.cramt || "0") : NumberToNepaliNum(formatMoney_2(voucher?.cramt || "0"))}.
                                            </td>
                                        </tr>
                                    ))
                                }
                                 <tr className='text-black bottom-0'>
                                    <td align='right' colSpan={2} className={`px-2 font-bold border-y border-gray-300 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Total Amount: " : "कुल रकम: "}
                                    </td>
                                    <td align='right' className={`px-2 font-bold text-black border-y border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng"
                                            ? formatMoney_2(totalAmount)
                                            : NumberToNepaliNum(formatMoney_2(totalAmount))}
                                    </td>
                                </tr>
                                <tr className='text-black bottom-0'>
                                    <td align='right' colSpan={3} className={`px-2 font-bold border-y border-gray-300 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng"
                                            ? toWords.convert(totalAmount || 0)
                                            : toNpWords.convert(totalAmount|| 0)}
                                    </td>
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    <div className='items-end h-full px-2 py-2 flex justify-between'>
                        <div className={`text-[10px] text-center ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                            <h6>.............................</h6>
                            <h6 className={`text-gray-800 -mt-0.5 font-semibold ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}> {language === "Eng" ? "Received By" : "बुझिलेको सही"}</h6>
                        </div>
                        <div className={`text-[10px] text-center ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                            <h6>.............................</h6>
                            <h6 className='text-gray-800 -mt-0.5 font-semibold'>  {language === "Eng" ? "Authorized By" : "बुझाउनेको सही "}</h6>
                        </div>
                    </div>
                </div >
                <div className='bg-white m-1 h-[50vh] border border-gray-700 flex flex-col justify-between'>
                    <div className="relative p-2">
                        <table className="w-full text-sm text-left rtl:text-right text-black">
                            <tbody>
                                <tr>
                                    <td className={`w-[25%] text-[10px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        {language === "Eng" ? "Reg. No: " : "दर्ता नं.:"}:  {language === "Eng" ? org_details?.org_reg : NumberToNepaliNum(org_details?.org_reg || "")}
                                    </td>
                                    <td className="w-[25%]" style={{ padding: 0, margin: 0 }}>
                                    </td>
                                    <td className="w-[25%]" style={{ padding: 0, margin: 0 }}>
                                    </td>
                                    <td align='right' className={`w-[25%] text-[10px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        {language === "Eng" ? "Phone: " : "फोन नम्बर:"}  {language === "Eng" ? org_details?.org_phone : NumberToNepaliNum(org_details?.org_phone || 0)}
                                    </td>
                                </tr>
                                <tr>
                                    <td align='center' colSpan={4} className={`w-[100%] text-black font-bold text-[15px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        {language === "Eng" ? org_details?.org_name : org_details?.org_name_nep}
                                    </td>
                                </tr>
                                <tr>
                                    <td align='center' colSpan={4} className={`w-[25%] text-black font-medium text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        {language === "Eng" ? org_details?.org_add : org_details?.org_add_nep}
                                    </td>
                                </tr>
                                <tr>
                                    <td align='center' colSpan={4} className={`w-[25%] text-black font-bold text-[12px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} style={{ padding: 0, margin: 0 }}>
                                        <span className='underline'>{language === "Eng" ? "Office Receipt" : "कार्यालय रसिद"}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div className="relative mt-1">
                        <table className='w-full'>
                            <thead className="text-[12px] text-black capitalize">
                                <tr>
                                    <td align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Receipt No: " : "रसिद नं: "} {language === "Eng" ? BillingList?.receipt_no : BillingList?.receipt_no}
                                    </td>
                                    <td align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Date: " : "मिति: "} {language === "Eng" ? BillingList.date_ne || "" : BillingList.date_ne || ""}
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2} align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Name: " : "नाम: "} {language === "Eng" ? BillingList.member_details?.mem_name : BillingList.member_details?.mem_name_nep}
                                    </td>
                                </tr>
                                <tr>
                                    <td align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                       {language === "Eng" ? "Address: " : "ठेगाना: "} {language === "Eng" ? BillingList.member_details?.add_eng : BillingList.member_details?.add_nep}-{BillingList?.member_details?.ward_no || ""}
                                    </td>
                                    <td align='left' className={`px-1 font-normal border-t border-gray-300 w-[50%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Marga/Tole: " : "मार्गा/टोल: "} {language === "Eng" ? BillingList.member_details?.tole_name : BillingList.member_details?.tole_name_nep}
                                    </td>
                                </tr>
                            </thead>
                        </table>
                    </div>
                    <div className="relative mt-1">
                        <table className="w-full text-sm text-left rtl:text-right text-black ">
                            <thead className="text-[10px] text-black capitalize bg-gray200">
                                <tr>
                                    <td align='center' className={`px-1 border-y font-bold border-gray-300 w-10 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "S.N." : "स.नं."}
                                    </td>
                                    <td align='center' className={`px-1 border-[1px] font-bold border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Particulars" : "विवरणहरु"}
                                    </td>
                                    <td align='center' className={`px-1 border-y font-bold border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Amount" : "रकम"}
                                    </td>
                                </tr>
                            </thead>
                            <tbody className="text-[10px] font-normal text-gray600 capitalize">
                                {BillingList &&
                                    BillingList?.receipt_list?.map((voucher: any, index: number) => (
                                        <tr key={index} className='text-black'>
                                            <td align='center' className={`px-2 border-y font-normal border-gray-300 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                                {language === "Eng" ? index + 1 : NumberToNepaliNum(index + 1)}.
                                            </td>
                                            <td align='left' className={`px-2 font-normal border border-gray-300 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                                {language === "Eng" ? voucher?.particularname : voucher?.particularnamenep}.
                                            </td>
                                            <td align='right' className={`px-2 border-y border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                                {language === "Eng" ? formatMoney_2(voucher?.cramt || "0") : NumberToNepaliNum(formatMoney_2(voucher?.cramt || "0"))}.
                                            </td>
                                        </tr>
                                    ))
                                }
                              <tr className='text-black'>
                                    <td align='right' colSpan={2} className={`px-2 font-bold border-y border-gray-300 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng" ? "Total Amount: " : "कुल रकम: "}
                                    </td>
                                    <td align='right' className={`px-2 border-y font-bold text-black border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                        {language === "Eng"
                                            ? formatMoney_2(totalAmount)
                                            : NumberToNepaliNum(formatMoney_2(totalAmount))}
                                    </td>
                                </tr>
                                <td align='right' colSpan={3} className={`px-2 font-bold border-y border-gray-300 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                                    {language === "Eng"
                                        ? toWords.convert(totalAmount || 0)
                                        : toNpWords.convert(totalAmount || 0)}

                                </td> 
                            </tbody>
                        </table>
                    </div>
                    <div className='items-end h-full px-2 py-2 flex justify-between'>
                        <div className={`text-[10px] text-center ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                            <h6>.............................</h6>
                            <h6 className={`text-gray-800 -mt-0.5 font-semibold ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}> {language === "Eng" ? "Received By" : "बुझिलेको सही"}</h6>
                        </div>
                        <div className={`text-[10px] text-center ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                            <h6>.............................</h6>
                            <h6 className='text-gray-800 -mt-0.5 font-semibold'>  {language === "Eng" ? "Authorized By" : "बुझाउनेको सही "}</h6>
                        </div>
                    </div>
                </div >

            </div>
        </Fragment>
    )
}

export default BillPrintView